// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest } from '@/libs/axios';


//版权存证-电子数据确认函 /notarial/enc/generateEncByOrderCommon
export const _generateEncByOrderCommon = (params) =>{
    return postRequest('/notarial/enc/generateEncByOrderCommon',params)
}

//版权取证-电子数据确认函函接口 /notarial/enc/generateEncByEvidencePage
export const _generateEncByEvidencePage = (params) =>{
    return postRequest('/notarial/enc/generateEncByEvidencePage',params)
}

//电子公证函证书查询接口 /notarial/enc/downloadEnc/{orderSeqNo}
export const _downloadEnc = (id,params) =>{
    return getRequest(`/notarial/enc/downloadEnc/${id}`,params)
}

//分页获取电子公证函列表接口 /notarial/enc/getByPage
export const _getNotarizationPage = (params) =>{
    return getRequest('/notarial/enc/getByPage',params)
}

//通过id获取电子公证函接口 /notarial/enc/get/{id}
export const _getNotarizationData= (id,params) =>{
    return getRequest(`/notarial/enc/get/${id}`,params)
}

